import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from 'app/rootReducer'
import GoBackHeader from 'components/organisms/GoBackHeader'
import Button from 'react-bootstrap/Button'
import './styles.scss'
import { useMutation } from '@apollo/client'
import {
  UPDATE_DOCUMENT,
  UpdateDocumentResponse,
  UpdateDocumentVariables
} from 'share/mutations/documents'
import DocumentsAddReplaceModal from '../DocumentsAddReplaceModal'
import { setSelectedDocument } from 'reducers/document/documentProcessingSlice'

const DocumentDetail = (): JSX.Element => {
  const [showDocumentsAddReplaceModal, setShowDocumentsAddReplaceModal] =
    useState(false)
  const documentProcessing = useSelector(
    (state: RootState) => state.documentProcessing
  )
  const history = useHistory()
  const dispatch = useDispatch()
  const [updateDocument, { data, error }] =
    useMutation<UpdateDocumentResponse, UpdateDocumentVariables>(
      UPDATE_DOCUMENT
    )
  const [docName, setDocName] = useState(
    documentProcessing.selectedDocument?.name
  )

  useEffect(() => {
    setDocName(documentProcessing.selectedDocument?.name)
  }, [showDocumentsAddReplaceModal])

  useEffect(() => {
    if (data && !error) {
      dispatch(setSelectedDocument(data.documents.update))
      history.push('/dashboard/documents/detail')
    }
  }, [error, data])

  return (
    <>
      <GoBackHeader text='Edit Document' />
      <div className='ui-docs-edit-container'>
        <h2 data-testid='document-edit-title'>Edit Document</h2>
        <p>Document Name</p>
        <div className='ui-docs-edit-form'>
          <span className='mdi mdi-file-pdf' />
          <input
            data-testid='document-edit-input'
            onChange={(e) => setDocName(e.target.value)}
            value={docName}
          />
        </div>
        <div className='ui-docs-edit-buttons'>
          <Button
            data-testid='document-edit-save-button'
            variant='primary'
            className='ui-save-button'
            onClick={() => {
              if (!documentProcessing.selectedDocument || !docName) return
              updateDocument({
                variables: {
                  document: {
                    id: documentProcessing.selectedDocument.id,
                    name: docName
                  }
                }
              })
            }}
          >
            Save
          </Button>
          <Button
            data-testid='document-edit-cancel-button'
            variant='outline-secondary'
            onClick={() => history.push('/dashboard/documents/detail')}
          >
            Cancel
          </Button>
        </div>
        {documentProcessing.selectedDocument?.status &&
          documentProcessing.selectedDocument?.status !== 'Accepted' && (
            <div className='ui-replace-button'>
              <Button
                data-testid='document-edit-replace-button'
                variant='link'
                onClick={() => {
                  setShowDocumentsAddReplaceModal(true)
                }}
              >
                Replace Document
              </Button>
            </div>
          )}
      </div>
      {documentProcessing.selectedDocument?.status &&
        documentProcessing.selectedDocument?.status !== 'Accepted' && (
          <DocumentsAddReplaceModal
            title='Replace Document'
            show={showDocumentsAddReplaceModal}
            onHide={() => {
              setShowDocumentsAddReplaceModal(false)
            }}
            replacedDocumentId={
              documentProcessing.selectedDocument?.id
                ? documentProcessing.selectedDocument?.id
                : null
            }
            businessObjectId={null}
            businessObjectType={''}
            folderName={
              documentProcessing?.selectedDocumentCategory?.name ?? ''
            }
            folderDescription={
              documentProcessing?.selectedDocumentCategory?.description ?? ''
            }
            isAiCase={false}
          />
        )}
    </>
  )
}

export default DocumentDetail
